import { getProductCategories } from "@dillon/Services/CommonServices";
import { setGA4Event } from "@dillon/Store/Handlers/Utilities/CustomTracking";
import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, DispatchLoadPromotions } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

addToChainAfter(chain, DispatchLoadPromotions, async props => {
    // Verndale Customization ticket: DSSM-469
    const state = props.getState();

    const cartLines = props.apiResult.cart.cartLines || [];

    if (cartLines.length === 0) {
        return;
    }

    const result = await getProductCategories({
        productIds: [...cartLines.map(cl => cl.productId!)],
        type: "product",
    });

    if (result.successful) {
        const productCategories = result.result;
        const currentPath = window.location.pathname;
        if (currentPath === "/Cart") {
            setGA4Event(cartLines,"view_cart", {
                productCategories,
            });
        }
    }
    // End of Verndale Customization ticket: DSSM-469
});
